(function($) {
    'use strict';

    $( window ).on( 'load', function(){

        let user = awGetUserCookie();
        if(user.sub_type === 'S'){
            $('.issue-section-wrap .aw-issue-message a').css('display', 'none');
        }   
    });

})(jQuery);